<app-data-grid
  [mode]="'edit'"
  *ngIf="restaurantId"
  [state]="state"
  [fontSize]="fontSize"
  (valueChange)="cacheChanges()"
  [columns]="columns"
  [dataItems]="changeset"
  [filterable]="'menu'"
  (dataStateChange)="fetchChangesets($event)"
  (filterChange)="filterChanged($event)"
>
  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="comboName"
  >
    <app-custom-filter
      [view]="type"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
      [restaurantId]="restaurantId"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="entreeParId"
  >
    <app-custom-filter
      [view]="type"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
      [restaurantId]="restaurantId"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="comboParId"
  >
    <app-custom-filter      
      [view]="type"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
      [restaurantId]="restaurantId"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="entreeName"
  >
    <app-custom-filter
      [view]="type"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      [productType]="productTypeId"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
      [restaurantId]="restaurantId"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    columnTemplate
    field="entreeName"
    let-row="row"
    let-column="column"
  >
    {{ row[column.field] }}
    <button
      *ngIf="row.status == 'Pending Availability'"
      kendoButton
      [title]="'This item is pending sync to PAR'"
      class="m-l-4 info-bg badge-button"
      size="small"
      rounded="full"
    >
      Pending
    </button>

    <button
      *ngIf="row.hasDirty()"
      kendoButton
      [title]="'This item has unsaved changes'"
      class="m-l-4 warning-bg badge-button"
      size="small"
      rounded="full"
    >
      Unsaved
    </button>

    <button
      *ngIf="row.status == 'Scheduled Availability'"
      kendoButton
      [title]="'This item is scheduled to sync with PAR'"
      class="m-l-4 success-bg badge-button"
      size="small"
      rounded="full"
    >
      Scheduled
    </button>
  </ng-template>
</app-data-grid>
